export default "__VITE_ASSET__5w2tjK2d__"